import api from "APP_ROOT/api";
import { createPaginatedList } from "MODULES/shared/pagination";

export default createPaginatedList({
  listId: "searchNotifications",
  fetch: api.notifications.search,
  stateLocator: state => state.searchNotifications,
  initialSettings: {
    sort: "id",
    sortReverse: true,
    filters: {
      filter: true
    }
  }
});



// WEBPACK FOOTER //
// ./app/modules/Notifications/pagination.js